import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';

import { Const } from '../const';

import { environment } from '../../environments/environment';

import { SystemAlerts } from '../servicer/models/system-alerts';
import { SystemAlertsServiceProvider } from '../servicer/system-alerts-service';
import { SystemAlertsApiParameter } from '../servicer/models/system-alerts-parameter';

/**
 * alertsを定期間隔で取得するプロバイダー.
 */
@Injectable()
export class SystemAlertsIntervalReceiverProvider {
  /** 空のレスポンス. */
  private readonly alertsEmptyResponse = null;

  /** alerts情報. */
  public alertsInfos$: BehaviorSubject<SystemAlerts[]> = new BehaviorSubject<SystemAlerts[]>(this.alertsEmptyResponse);

  /** インターバルのSubscription. */
  private intervalSubscription: any = null;

  /** パラメータ. */
  private areaIds: number[];
  private alertLastNotificationAt: number = null;

  /** 実行中. */
  private processing = false;

  constructor(
    public systemAlertsService: SystemAlertsServiceProvider
  ) { }

  /**
   * 開始.
   */
  start() {
    this.areaIds = [environment.areas[environment.areaIndex].spokeAreaId, environment.areas[environment.areaIndex].hubAreaId];
    this.execute();
    // 重複してintervalを起動しない
    if (!this.intervalSubscription) {
      this.intervalSubscription = Observable.interval(environment.systemDashboardInterval).subscribe(() => this.execute());
    }
  }

  /**
   * 実行します.
   */
  execute() {
    const parameter: SystemAlertsApiParameter = {
      areaIds: this.areaIds,
      alertLastNotificationAt: this.alertLastNotificationAt
    };
    of(this.processing)
      .filter((processing) => !processing)
      .pipe(tap(() => this.processing = true))
      .flatMap(() => this.get(parameter))
      .pipe(tap(() => this.processing = false))
      .subscribe();
  }

  /**
   * 停止.
   */
  stop() {
    this.alertsInfos$.next(this.alertsEmptyResponse);

    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
      //clearInterval(this.intervalSubscription);
      this.intervalSubscription = null;
    }
  }

  /**
   * alerts表示情報を取得します.
   * 定期的に呼び出されるため、エラーが発生しても、何も処理をしません.
   */
  private get(parameter: SystemAlertsApiParameter): Observable<SystemAlerts[]> {
    return this.systemAlertsService.getAlerts(parameter)
      .map((response) => {
        if (response.result === Const.ResponseResult.SUCCESS) {
          this.alertsInfos$.next(response.items);
        }

        return this.alertsInfos$.value;
      })
      .catch((error) => {
        console.error(error);
        return Observable.of(this.alertsInfos$.value);
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/system-alerts-interval-receiver/system-alerts-interval-receiver.ts